import _taggedTemplateLiteral from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components';
import * as RdIcons from '@accesa/fonts/webfonts/RD-Icons/rd-icons.ttf';
export var RadiodataFontFace = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    @font-face {\n        font-family: 'Ratiodata Icons';\n        font-style: normal;\n        src: url('", "') format('truetype');\n    }\n"])), RdIcons);